export const trackPageView = (url, tagName) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pageview",
    page: {
      url: url,
      tagName: tagName,
    },
  });
};

export const trackEvent = ({ category, action, label, value }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "event",
    eventProps: {
      category,
      action,
      // label,
      // value
    },
  });
};
